<template>
  <modal width="55" :show-modal="showModal" @close-modal="$emit('close-modal')" title="Pricing & Tier Info">
    <div class="delete-modal">
      <p class="w-full text-left my-3">
        Partners are moved upwards or downwards (at the beginning of every month) based on the aggregate revenue
        generated in the prior month.
      </p>
      <div class="flex border-b-2 border-gray-400 pt-2 mb-4">
        <div class="tab-item" :class="{ active: currentTab == 'Bike' }" @click="currentTab = 'Bike'">
          <p>Bike</p>
        </div>
        <div class="tab-item" :class="{ active: currentTab == 'Car' }" @click="currentTab = 'Car'">
          <p>Cars</p>
        </div>
        <div class="tab-item" :class="{ active: currentTab == 'Truck' }" @click="currentTab = 'Truck'">
          <p>Truck</p>
        </div>
      </div>

      <div>
        <div class="w-full flex justify-end border-r-[1px] border-r-gray-400 blend_div">
          <span class="trans_sec b_right">Monthly Cummulative</span>
          <span class="trans_sec w_wide">Per Transaction</span>
        </div>
        <table class="custom-table responsive-table border-collapse m-0">
          <thead class="font-normal">
            <tr class="rounded-lg bg-backgroundGrey">
              <th>Commission Tier</th>
              <th>Threshold(₦)</th>
              <th>Commission Rate</th>
              <th>Commission Cap</th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr v-for="(tier) in priceDetails" :key="tier.id"
              class="rounded-lg border-b-[1px] border-gray-500">
              <td>
                {{ tier.tierName || 'N/A' }}
              </td>
              <td class="whitespace-nowrap">
                {{ `&lt; ${ formatAmount(tier.maxCost) }` }}
              </td>
              <td>{{ tier.commissionRate || 0 }}%</td>
              <td>
                {{ formatAmount(tier.commissionCap) }}
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </modal>
</template>

<script>
//   import ArrowDownBlackIcon from "@/components/UI/svgs/ArrowDownBlackIcon.vue";

export default {
  components: {
    //   ArrowDownBlackIcon
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      shipmentCategories: ["Parcel", "Document", "Electronic Device", "Others"],
      priceDetails: [],
      currentTab: 'Bike'
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getPriceInfo()
      }
    },
    currentTab(){
      this.getPriceInfo()
    }
  },
  methods: {
    formatAmount(number){
        return number ? number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    },
    async getPriceInfo() {
      let response = await this.$_getViewPriceTier(this.currentTab)
      this.priceDetails = response.data.data.pricingTeirs
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.delete-modal {
  text-align: center;
}

.w_semi {
  @apply w-[48%] flex items-center
}

.drp-content {
  @apply w-full border-[1px] h-full py-[8px] rounded flex items-center justify-between px-2;

  span {
    @apply flex items-center
  }
}

.vrt_line {
  @apply w-[1px] h-[17px] bg-gray-400 inline-block mx-2
}

.tab-item {
  cursor: pointer;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}

td {
  text-align: left;
}

th {
  text-align: left;
}

.trans_sec {
  @apply inline-block px-4 py-1 bg-primary-yellow/30
}

.w_wide {
  @apply sm:w-[220px]
}

.b_right {
  @apply border-r-[1px] border-r-gray-400
}

.blend_div {
  @apply relative top-2
}
</style>